export enum TABS {
  GENERAL_INFORMATION = "general-information",
  NOTIFICATION_SETTINGS = "notification-settings",
}

export const tabsLabels: TABS[] = [
  TABS.GENERAL_INFORMATION,
  TABS.NOTIFICATION_SETTINGS,
];
